<template>
  <div class="step-container">
    <div class="step-title" v-if="showReleaseSelector && !switchToURL">
      <span>Choose a Release</span>
      <span class="switch" @click="switchToURL = true">Enter URL instead?</span>
    </div>
    <div class="step-title" v-else>
      <span>Enter Source Link</span>
      <span
        class="switch"
        v-if="showReleaseSelector"
        @click="switchToURL = false"
      >
        Choose from Releases instead?
      </span>
    </div>
    <div class="step-content">
      <template v-if="showReleaseSelector && !switchToURL">
        <template v-if="selectedRelease">
          <div class="selected-release">
            <div class="selected">Selected:</div>
            <div class="release-card">
              <div class="release-image">
                <img :src="selectedRelease.cover_image" />
              </div>
              <div class="release-text-album">
                <div class="release-text">
                  <span class="release-title">{{ selectedRelease.name }}</span>
                  <span class="release-type"
                    >&nbsp;• {{ selectedRelease.type }}</span
                  >
                </div>
                <div
                  class="release-album-name"
                  v-if="selectedRelease.album_name"
                >
                  {{ selectedRelease.album_name }}
                </div>
              </div>
              <div class="cancel" @click="cancelSelectRelease">
                <span>x Cancel</span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="releases.length">
          <div class="input-box search-release">
            <SearchIcon class="search-icon" />
            <input
              v-model="searchInput"
              type="text"
              placeholder="Search your releases"
            />
          </div>
          <div class="release-list">
            <div class="type-filter-container">
              <div class="type-filter">
                <div
                  class="type-filter-item"
                  :class="{ selected: selectedReleaseType === 'Track' }"
                  @click="selectedReleaseType = 'Track'"
                >
                  Tracks
                </div>
                <div
                  class="type-filter-item"
                  :class="{ selected: selectedReleaseType === 'Album' }"
                  @click="selectedReleaseType = 'Album'"
                >
                  Albums
                </div>
              </div>
            </div>
            <div
              class="release-card"
              v-for="release in searchResults"
              :key="release.id"
              @click="(selectedRelease = release), getMeta()"
            >
              <div class="release-image">
                <img :src="release.cover_image" />
              </div>
              <div class="release-text-album">
                <div class="release-text">
                  <span class="release-title">{{ release.name }}</span>
                  <span class="release-type">&nbsp;• {{ release.type }}</span>
                </div>
                <div class="release-album-name" v-if="release.album_name">
                  {{ release.album_name }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <Loader />
        </template>
      </template>
      <template v-else>
        <span class="description" v-if="linkType === 'Podcast'">
          Start by entering the Spotify or Apple Podcasts Link
        </span>
        <span class="description" v-else>
          Start by entering the Spotify or Apple Music Link
        </span>
        <div class="input-box">
          <SpotifyIcon class="spotify-icon" />
          <!--  -->
          <input v-model="source_input" type="text" @paste="getMeta" placeholder="Spotify Link" />
        </div>
      </template>
      <span class="note">
        Please note that updating this will trigger a rescan and reset the
        current services, landing page, preview, and metadata settings.
      </span>
      <template v-if="sourceLoaded">
        <div class="separator"></div>
        <div class="source-card">
          <div class="source-image">
            <img :src="source.image" />
          </div>
          <div class="source-text">
            <span class="source-title">
              {{ source.artists }}
            </span>
            <span class="source-subtitle">
              {{ source.releaseTitle }}
            </span>
          </div>
        </div>
      </template>
    </div>
    <div class="step-actions">
      <div @click="back()" class="back">
        <ArrowLeftIcon />
        <span class="back-text">BACK</span>
      </div>
      <button @click="!sourceLoaded ? getMeta() : next()" class="button-default big btn">
        <span>Next</span>
      </button>
    </div>
    <SnackBar>
      <template v-slot:icon></template>
    </SnackBar>
  </div>
</template>
<script>
import SpotifyIcon from "../../../public/img/icons/spotify.svg";
import SearchIcon from "../../../public/img/icons/search.svg";
import {
  Q_GET_SPOTIFY_PREVIEW_URL,
  Q_META,
  M_RID_FROM_LINK,
  M_LINKS_FROM_RID,
  Q_GET_ARTIST_RELEASES,
} from "@/graphql";
import SnackBar from "@/components/Custom/SnackBar";
import ArrowLeftIcon from "../../../public/img/icons/arrow-left.svg";
import Loader from "@/components/Custom/Loader.vue";
export default {
  name: "CreateLinkWizardStepTwo",
  components: {
    ArrowLeftIcon,
    SpotifyIcon,
    SnackBar,
    Loader,
    SearchIcon,
  },
  data() {
    return {
      source_input: null,
      rid: null,
      link_type: null,
      metadata: {},
      searchInput: "",
      releases: [],
      selectedRelease: null,
      selectedReleaseType: "Track",
      switchToURL: false,
      destination_defaults: {
        spotify: {
          name: "Spotify",
          type: "spotify",
          default_cta: "Stream on Spotify",
          text: "Stream on Spotify",
        },
        applemusic: {
          name: "Apple Music",
          type: "applemusic",
          default_cta: "Stream on Apple Music",
          text: "Stream on Apple Music",
        },
        amazonmusic: {
          name: "Amazon Music",
          type: "amazonmusic",
          default_cta: "Play on Amazon Music",
          text: "Play on Amazon Music",
        },
        deezer: {
          name: "Deezer",
          type: "deezer",
          default_cta: "Play on Deezer",
          text: "Play on Deezer",
        },
        itunes: {
          name: "iTunes",
          type: "itunes",
          default_cta: "Buy on iTunes",
          text: "Buy on iTunes",
        },
        pandora: {
          name: "Pandora",
          type: "pandora",
          default_cta: "Play on Pandora",
          text: "Play on Pandora",
        },
        tidal: {
          name: "Tidal",
          type: "tidal",
          default_cta: "Play on Tidal",
          text: "Play on Tidal",
        },
        soundcloud: {
          name: "SoundCloud",
          type: "soundcloud",
          default_cta: "Play on SoundCloud",
          text: "Play on SoundCloud",
        },
        youtube: {
          name: "YouTube",
          type: "youtube",
          default_cta: "Watch on YouTube",
          text: "Watch on YouTube",
        },
        bandcamp: {
          name: "Bandcamp",
          type: "bandcamp",
          default_cta: "Download on Bandcamp",
          text: "Download on Bandcamp",
        },
        applepodcasts: {
          name: "Apple Podcasts",
          type: "applepodcasts",
          default_cta: "Listen on Apple Podcasts",
          text: "Listen on Apple Podcasts",
        },
      },
      // sourceLoaded: false
      // source: {
      //   image: null,
      //   title: null,
      //   subtitle: null,
      //   description: null,
      //   theme: "light",
      //   display_artist_socials: true,
      //   domain: "vibe.to",
      //   destinations: []
      // }
    };
  },
  created() {
    if (this.sourceLink) {
      this.source_input = this.sourceLink;
    }
    // if (this.artist?.spotify_id) {
    //   this.source_input = `http://open.spotify.com/artist/${this.artist.spotify_id}`;
    //   this.getMeta();
    // }

    if (this.showReleaseSelector) this.getReleases();
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    linkType() {
      const { link_type } = this.$store.state.createLinkWizardData;
      return link_type[0].toUpperCase() + link_type.substring(1);
    },
    sourceLink() {
      return this.$store.state.createLinkWizardData.source_input;
    },
    source() {
      return this.$store.state.createLinkWizardData;
    },
    sourceLoaded() {
      return this.$store.state.createLinkWizardData.source_destination.url;
    },
    searchResults() {
      return this.releases.filter(
        release =>
          (!this.searchInput ||
            release.name
              .toLowerCase()
              .includes(this.searchInput.toLowerCase())) &&
          release.type === this.selectedReleaseType
      );
    },
    showReleaseSelector() {
      return this.linkType === "Release" && this.artist?.spotify_id;
    },
  },
  methods: {
    back() {
      this.$emit("back");
    },
    next() {
      this.$emit("setStep", 3);
    },
    async getSpotifyPreview(link) {
      try {
        const r = await this.$apollo.query({
          client: "localClient",
          query: Q_GET_SPOTIFY_PREVIEW_URL,
          variables: {
            link: link,
          },
        });
        console.log("Q_GET_SPOTIFY_PREVIEW_URL", r);
        const { preview_url } = r.data.get_spotify_preview_url;
        console.log(preview_url);
        // this.source.preview_url = preview_url;
        // await this.$store.dispatch("snack", {
        //   text: "Success! Spotify Preview URL saved."
        // });
        return preview_url;
      } catch (e) {
        console.log(e);
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Oops! Invalid URL.",
        });
      }
    },
    validateRid(value) {
      return !!value.match(/^[A-Z]{2}-?\w{3}-?\d{2}-?\d{5}$/);
    },
    async getRidFromLink() {
      const r = await this.$apollo.mutate({
        mutation: M_RID_FROM_LINK,
        client: "localClient",
        variables: {
          link: this.source_input,
        },
      });
      const { rid, type: link_type } = r.data.rid_from_link;
      return rid ? { rid, link_type } : {};
    },
    async getLinksFromRid() {
      const r = await this.$apollo.mutate({
        mutation: M_LINKS_FROM_RID,
        client: "localClient",
        variables: {
          rid: this.rid,
          type: this.link_type || "track",
        },
      });
      return r.data.links_from_rid.links || [];
    },
    getMeta() {
      setTimeout(async () => {
        if (this.selectedRelease) {
          this.source_input = this.selectedRelease.url;
        }

        if (!this.source_input) {
          this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! This doesn't look like a valid source link.",
          });
          return;
        }

        let isRid;
        isRid = this.validateRid(this.source_input);
        let destinations = [];
        let autoDetectedDestinations = [];
        if (this.linkType === "Release") {
          if (isRid) {
            this.rid = this.source_input;
            this.source_input = null;
          } else {
            await this.$store.dispatch("snack", {
              text: "Retrieving ISRC from link, please wait...",
              autoDismiss: false,
            });

            const { rid, link_type } = await this.getRidFromLink();

            if (rid) {
              this.rid = rid;
              this.link_type = link_type;
            }
          }

          if (this.rid) {
            await this.$store.dispatch("snack", {
              text: "Auto-populating links, please wait...",
              autoDismiss: false,
            });

            const links = await this.getLinksFromRid();

            let sourcePlatform = null;
            if (this.source_input) {
              sourcePlatform = new URL(this.source_input).host
                .split(".")
                .slice(-2, -1)
                .pop();
            }

            for (const { platform, url } of links) {
              if (platform === "tiktok") continue;
              let adjustedUrl = url;
              const pathParts = new URL(url).pathname.split("/");
              if (url.includes("spotify.com") && pathParts.length > 3) {
                adjustedUrl = `https://open.spotify.com/${pathParts.slice(2).join("/")}`;
              }

              const r = await this.$apollo.query({
                query: Q_META,
                client: "localClient",
                variables: { url: adjustedUrl }
              });

              const metaData = JSON.parse(r.data.meta.data);

              const destination = {
                ...this.destination_defaults[platform],
                url: adjustedUrl,
                logo: metaData.domain_image,
                type: platform,
                cta: this.destination_defaults[platform].default_cta,
                enabled: true,
                deeplink_android: metaData.deeplinks?.android || null,
                deeplink_ios: metaData.deeplinks?.ios || null,
              };

              if (platform === "spotify") {
                destination.preview_url = await this.getSpotifyPreview(url);
              }

              if (sourcePlatform && platform.includes(sourcePlatform)) {
                destinations.push({ ...destination, showDeeplinks: false });
                this.source_input = url;
              }

              autoDetectedDestinations.push(destination);
            }

            // const fetchedPlatforms = links.map(({ platform }) => platform);
            // for (const [key, destination] of Object.entries(
            //   this.destination_defaults
            // )) {
            //   if (!fetchedPlatforms.includes(key)) {
            //     destinations.push({
            //       ...destination,
            //       url: null,
            //       cta: destination.default_cta,
            //       enabled: false
            //     });
            //   }
            // }
          }

          this.$store.commit("resetSnack");

          if (!this.source_input && autoDetectedDestinations.length) {
            this.source_input = autoDetectedDestinations[0].url;
          }
        }

        if (
          !this.source_input.includes("open.spotify.com") &&
          !this.source_input.includes("music.apple.com") &&
          !this.source_input.includes("podcasts.apple.com")
        ) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! This doesn't look like a valid source link.",
          });
          this.source_input = null;
          return;
        }

        await this.$store.dispatch("snack", {
          text: "Loading metadata, please wait...",
          autoDismiss: false,
        });

        let adjustedUrl = this.source_input;
        const pathParts = new URL(this.source_input).pathname.split("/");
        if (this.source_input.includes("spotify.com") && pathParts.length > 3) {
          adjustedUrl = `https://open.spotify.com/${pathParts.slice(2).join('/')}`;
        }

        const r = await this.$apollo.query({
          query: Q_META,
          client: "localClient",
          variables: { url: adjustedUrl }
        });

        this.$store.commit("resetSnack");

        const metaData = JSON.parse(r.data.meta.data);
        this.metaData = metaData;

        let cool = false;

        // artist or user profile (BIO)
        if (this.linkType === "Bio") {
          // check if link type matches
          if (!["music.musician", "profile"].includes(metaData["og_type"])) {
            await this.$store.dispatch("snack", {
              type: "error",
              text: "Oops! This doesn't look like a Spotify artist link.",
            });
          } else if (metaData["og_url"].includes("open.spotify.com")) {
            destinations.push({
              ...this.destination_defaults.spotify,
              url: metaData["og_url"],
              logo: metaData.domain_image,
              type: "spotify",
              cta: this.destination_defaults.spotify.default_cta,
              deeplink_android: metaData.deeplinks?.android || null,
              deeplink_ios: metaData.deeplinks?.ios || null,
              showDeeplinks: false,
              enabled: true,
            });
            cool = true;
          } else {
            cool = true;
          }
          // playlist (PLAYLIST)
        } else if (this.linkType === "Playlist") {
          // check if link type matches
          if (!["music.playlist"].includes(metaData["og_type"])) {
            await this.$store.dispatch("snack", {
              type: "error",
              text: "Oops! This doesn't look like a Spotify playlist link.",
            });
          } else {
            // no need to check playlist for artist match yet
            destinations.push({
              ...this.destination_defaults.spotify,
              url: metaData["og_url"],
              logo: metaData.domain_image,
              type: "spotify",
              cta: this.destination_defaults.spotify.default_cta,
              enabled: true,
              deeplink_android: metaData.deeplinks?.android || null,
              deeplink_ios: metaData.deeplinks?.ios || null,
              showDeeplinks: false,
            });

            cool = true;
          }
          // song or album (RELEASE)
        } else if (this.linkType === "Release") {
          // check if link type matches
          if (!["music.song", "music.album"].includes(metaData["og_type"])) {
            await this.$store.dispatch("snack", {
              type: "error",
              text:
                "Oops! This doesn't look like a Spotify song or album link.",
            });
          } else {
            cool = true;
            /*
            if (
              metaData["musicMusician"]
                .map(x => x.substring(32))
                .includes(this.artist.spotify_id) ||
              [metaData["og_title"], metaData["og_description"]].find(x =>
                x.includes(this.artist.name)
              )
            ) {
              cool = true;
            } else {
              await this.$store.dispatch("snack", {
                type: "error",
                text:
                  "Oops! This appears to be a different artist than the one you are signed in as."
              });
            }
            */
          }
        } else if (this.linkType === "Podcast") {
          if (
            !["podcast.show", "podcast.episode"].includes(metaData["og_type"])
          ) {
            await this.$store.dispatch("snack", {
              type: "error",
              text:
                "Oops! This doesn't look like a Spotify/Apple Podcasts show or episode link.",
            });
          } else {
            const destination = this.source_input.includes("podcasts.apple.com")
              ? this.destination_defaults.applepodcasts
              : this.destination_defaults.spotify;

            destinations.push({
              ...destination,
              url: metaData["og_url"],
              logo: metaData.domain_image,
              cta: destination.default_cta,
              enabled: true,
              deeplink_android: metaData.deeplinks?.android || null,
              deeplink_ios: metaData.deeplinks?.ios || null,
              showDeeplinks: false,
            });

            cool = true;
          }
        }

        if (cool) {
          let source_destination;
          if (adjustedUrl.includes("music.apple.com")) {
            source_destination = {
              name: "Apple Music",
              type: "applemusic",
            };
          } else if (adjustedUrl.includes("podcasts.apple.com")) {
            source_destination = {
              name: "Apple Podcasts",
              type: "applepodcasts",
            };
          } else {
            source_destination = {
              name: "Spotify",
              type: "spotify",
              preview: await this.getSpotifyPreview(adjustedUrl),
            };
          }

          const source = {
            source_input: adjustedUrl,
            image: metaData["og_image"],
            releaseTitle: metaData["og_title"],
            title:
              this.linkType === "Release"
                ? `${metaData["og_title"]} by ${metaData["og_author"]}`
                : metaData["og_title"],
            artists: metaData["og_author"],
            subtitle: "",
            description: "",
            theme: "light",
            display_artist_socials: true,
            domain: "vibe.to",
            rid: this.rid,
            layout: 2,
            source_destination: {
              ...source_destination,
              logo: this.metadata["domain_image"],
              url: this.metaData["og_url"],
            },
            destinations,
            autoDetectedDestinations,
            cover_image_style: "full",
          };
          this.$store.commit("setCreateLinkWizardData", source);
          // this.sourceLoaded = true;
        } else {
          this.source_input = null;
        }
      });
    },
    cancelSelectRelease() {
      this.selectedRelease = null;
      this.$store.commit("setCreateLinkWizardData", {
        source_input: null,
        source_destination: {},
      });
    },
    getReleases() {
      this.$apollo
        .query({
          query: Q_GET_ARTIST_RELEASES,
          variables: {
            artist_id: this.artist.id,
          },
          client: "localClient",
        })
        .then((r) => {
          this.releases = r.data.get_artist_releases.releases;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.step-container {
  padding-top: 60px;
  display: flex;
  flex-direction: column;

  .step-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: white;
    mix-blend-mode: normal;
    opacity: 0.9;

    .switch {
      margin-top: 10px;
      font-size: 14px;
      line-height: 17px;
      /* Text/type2 */
      color: $purple;
      text-decoration: underline;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .step-subtitle {
    display: block;
    text-align: center;
    margin-top: 6px;
    /* 16/Regular */
    font-size: 16px;
    line-height: 24px;
    /* Text/type2 */
    color: $text-type-2;
  }

  .step-content {
    margin-top: 30px;
    max-width: 620px;

    .selected-release {
      margin-bottom: 40px;

      .release-card {
        padding: 10px 0;
        display: flex;
        align-items: center;

        .release-image {
          display: flex;
          justify-content: center;

          img {
            border-radius: 10px;
            width: 40px;
            height: 40px;
            object-fit: cover;
          }
        }

        .release-text-album {
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .release-text {
            display: flex;
            align-items: center;
            font-size: 15px;

            .release-title {
              color: #ffffff;
            }

            .release-type {
              color: $text-type-0;
            }
          }

          .release-album-name {
            font-size: 14px;
            color: #dedede;
          }
        }

        .cancel {
          margin-left: auto;

          span {
            font-size: 14px;
            color: $purple;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }

    .release-list {
      display: flex;
      flex-direction: column;
      background: $purple-dark;
      border-radius: 10px;
      height: 50vh;
      overflow-y: scroll;
      padding: 0 0 10px;
      margin-bottom: 40px;

      .type-filter-container {
        background: $purple-dark;
        position: sticky;
        top: 0;

        .type-filter {
          display: flex;
          margin: 20px 32px 10px;
          border-radius: 25px;
          background: $bg-type-0;
          width: fit-content;

          .type-filter-item {
            padding: 12px 15px;
            font-size: 15px;
            color: #dedede;
            border-radius: 25px;
            background: $bg-type-4;
            &:hover {
              cursor: pointer;
            }
            &.selected {
              background: $bg-type-2;
            }
          }
        }
      }

      .release-card {
        padding: 10px 32px;
        display: flex;

        &:hover {
          background: $bg-type-1;
          cursor: pointer;
        }

        .release-image {
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            border-radius: 10px;
            width: 40px;
            height: 40px;
            object-fit: cover;
          }
        }

        .release-text-album {
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 8px;

          .release-text {
            display: flex;
            align-items: center;
            font-size: 15px;

            .release-title {
              color: #dedede;
            }

            .release-type {
              color: $text-type-0;
            }
          }

          .release-album-name {
            font-size: 13px;
            color: #dedede;
          }
        }
      }
    }

    .description {
      /* 16/Regular */
      font-size: 16px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
    }

    .input-box {
      margin-top: 30px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      //width: 450px;
      //width: 100;
      padding: 0 20px;
      /* Purple-dark */
      background: $purple-dark;
      border-radius: 10px;

      .spotify-icon {
        path {
          fill: $text-type-2;
        }
      }

      input {
        z-index: 99;
        background: $purple-dark;
        flex: 1;
        padding: 12px;
        color: $text-type-2;
        border: none;
        /* 14/Regular */
        font-size: 14px;
        line-height: 17px;

        &:focus {
          outline: none;
          border: none;
        }

        &::placeholder {
          color: $text-type-2;
          /* 14/Regular */
          font-size: 14px;
          line-height: 17px;
        }
      }
    }

    .search-release {
      border: 2px solid $bg-type-2;
      margin-bottom: 15px;
      margin-top: 0;

      .search-icon {
        path {
          fill: $text-type-0;
        }
      }
    }

    .note {
      /* 12/Regular */
      font-size: 12px;
      line-height: 15px;
      /* Text/type1 */
      color: $text-type-1;
      text-align: center;
    }

    .separator {
      margin-top: 30px;
      width: 100%;
      height: 1px;
      background: $purple-dark;
    }

    .source-card {
      margin-top: 30px;
      display: flex;

      .source-image {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          /* Shadow-button */
          filter: drop-shadow(0px 0px 10px rgba(23, 18, 43, 0.45));
          border-radius: 1000px;
          width: 120px;
          height: 120px;
          object-fit: cover;
        }
      }

      .source-text {
        margin-left: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .source-title {
          /* 24/Bold */
          font-weight: bold;
          font-size: 24px;
          line-height: 32px;
          color: white;
        }

        .source-subtitle {
          /* 14/SemiBold */
          font-weight: 600;
          font-size: 14px;
          line-height: 32px;
          color: white;
        }
      }
    }
  }

  .step-actions {
    margin-top: auto;
    padding-top: 50px;
    padding-bottom: 60px;
    display: flex;
    justify-content: space-between;
    // display: grid;
    // grid-template-columns: 1fr 1fr;
    // grid-gap: 380px;
    .back {
      cursor: pointer;
      display: flex;
      //flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      &:hover {
        svg {
          path {
            fill: white;
          }
        }

        .back-text {
          color: white;
        }
      }

      svg {
        width: 28px;

        path {
          fill: #8786ab;
        }
      }

      .back-text {
        font-weight: 600;
        font-size: 14px;
        line-height: 14px;
        text-transform: uppercase;
        /* Text/type2 */
        color: $text-type-2;
      }
    }

    .button-default {
      padding: 9px 40px;
    }
  }
}

@media screen and (max-width: 600px) {
  .step-container {
    width: 80%;
  }
}
</style>
